import { render, staticRenderFns } from "./HighlightIt.vue?vue&type=template&id=4459d9fe&scoped=true&"
import script from "./HighlightIt.vue?vue&type=script&lang=ts&"
export * from "./HighlightIt.vue?vue&type=script&lang=ts&"
import style0 from "./HighlightIt.vue?vue&type=style&index=0&id=4459d9fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4459d9fe",
  null
  
)

export default component.exports